export default "__VITE_ASSET__GoyCWkai__"